<template>
  <div class='container-fluid'>
    <b-navbar toggleable='lg' type='dark' variant='primary' class='sticky-top'>
    <b-navbar-toggle target='nav_collapse'></b-navbar-toggle>
      <b-collapse is-nav id='nav_collapse'>
        <b-navbar-nav>
          <b-nav-item class='px-3' to='/home'>目的・目標</b-nav-item>
          <b-nav-item v-if="role == 'admin' || role == 'user'" class='px-3' to='/check'>ルーティンチェック表</b-nav-item>
          <b-nav-item class='px-3' to='/dashboard'>ダッシュボード</b-nav-item>
          <b-nav-item class='px-3' to='/chat'>チャット</b-nav-item>
          <b-nav-item v-if="role == 'admin' || role == 'user'" class='px-3' to='/routine'>個人ルーティン設定</b-nav-item>
          <b-nav-item v-if="role == 'admin' || role == 'owner'" class='px-3' to='/services'>サービス</b-nav-item>
          <b-nav-item v-if="role == 'admin' || role == 'owner' || role == 'coach'" class='px-3' to='/groups' exact>グループ</b-nav-item>
          <b-nav-item v-if="role == 'admin' || role == 'owner' || role == 'coach'" class='px-3' to='/users' exact>ユーザ</b-nav-item>
          <b-nav-item v-if="role == 'admin' || role == 'owner' || role == 'coach'" class='px-3' to='/routines' exact>ルーティン</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class='ml-auto'></b-navbar-nav>
        <b-navbar-nav>
          <b-nav-item-dropdown right>
            <template slot='button-content'>
                <img v-if='user && user.icon' :src='user.icon' width='30' height='30' alt=''>
                <i v-else class='fa fa-user' />
            </template>
            <b-dropdown-item href='#' @click.prevent='profile'><i class='fa fa-user' />プロフィール</b-dropdown-item>
            <b-dropdown-item v-if="user && user.role == 'admin'" href='#' @click.prevent='settings'><i class='fa fa-cog' />設定</b-dropdown-item>
            <b-dropdown-item href='#' @click.prevent='logout'><i class='fa fa-lock' />ログアウト</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <main class='main'>
      <Breadcrumb :list='list'/>
      <router-view></router-view>
    </main>

    <Footer class='fixed-bottom'>
      <div class='small'>
        <span class='m-1'>&copy; 2018 </span><a href='http://freewill.education'>Freewill</a><span> Total Education. </span>
      </div>
      <div class='ml-auto small'>
        <span class='mr-1'>Powered by</span>
        <a href='https://ubunifu.co'>UBUNIFU</a>
      </div>
    </Footer>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Footer from '@/components/Footer'

export default {
  name: 'full',
  components: {
    Footer,
    Breadcrumb
  },
  data () {
    return {
      role: 'user',
      unwatch: null
    }
  },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
      this.unwatch = null
    }
  },
  created () {
    if (this.user) {
      this.role = this.user.role
    }
    this.unwatch = this.$store.watch(state => this.$store.getters['authUser/user'], value => {
      if (this.user) {
        this.role = this.user.role
      }
    })
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    },
    ...mapGetters({
      user: 'authUser/user'
    })
  },
  methods: {
    profile () {
      this.$router.push('/profile')
    },
    settings () {
      this.$router.push('/settings')
    },
    logout () {
      var vm = this
      // vm.$store.dispatch('authUser/initUser')
      // vm.$store.dispatch('service/init')
      // vm.$store.dispatch('group/init')
      // vm.$store.dispatch('user/init')
      // vm.$store.dispatch('routine/init')
      // vm.$store.dispatch('routineGroup/init')
      // vm.$store.dispatch('routineRef/init')
      // vm.$store.dispatch('routineSelf/init')
      // vm.$store.dispatch('routineData/init')
      // vm.$store.dispatch('service/init')
      // vm.$store.dispatch('chatRef/init')
      // vm.$store.dispatch('chatMessage/init')
      vm.$store.dispatch('service/unSubscribe').then(() => {
        vm.$store.dispatch('group/unSubscribe').then(() => {
          vm.$store.dispatch('user/unSubscribe').then(() => {
            vm.$store.dispatch('routine/unSubscribe').then(() => {
              vm.$store.dispatch('routineGroup/unSubscribe').then(() => {
                vm.$store.dispatch('routineRef/unSubscribe').then(() => {
                  vm.$store.dispatch('routineSelf/unSubscribe').then(() => {
                    vm.$store.dispatch('routineData/unSubscribe').then(() => {
                      vm.$store.dispatch('authUser/unSubscribe').then(() => {
                        vm.$store.dispatch('chatRef/unSubscribe').then(() => {
                          vm.$store.dispatch('chatMessage/unSubscribe').then(() => {
                            vm.$store.dispatch('service/subscribe').then(() => {
                              vm.$store.dispatch('chatStatics/unSubscribe').then(() => {
                                firebase.auth().signOut().then(() => {
                                  vm.$store.dispatch('authUser/init', false)
                                  // vm.$store.dispatch('dispatch/setLoading', false)
                                  vm.$store.dispatch('authUser/init', false)
                                  vm.$store.dispatch('register/register', false)
                                  vm.$store.dispatch('dispatch/setAuth', false)
                                  vm.$store.dispatch('dispatch/setData', false)
                                  vm.$router.replace('/login')
                                })
                              })
                            })
                          })
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Container.vue